'use client';
/** @jsxImportSource @emotion/react */

import MuiAppBar from '@mui/material/AppBar';
import { type AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';

type ExcludedMuiProps = keyof Pick<
  MuiAppBarProps,
  'color' | 'elevation' | 'enableColorOnDark' | 'square' | 'variant'
>;

type AppBarProps = Omit<MuiAppBarProps, ExcludedMuiProps>;

export type { AppBarProps };

export const AppBar = MuiAppBar;
